export interface QuizzAnswer {
  value: string;
  label: string;
  displayAsRight: boolean;
  displayAsWrong: boolean;
}

export interface QuizzQuestion {
  name: string;
  label: string;
  correctValue: string;
  selectedValue: string;
  rightAnswerText: string;
  wrongAnswerText: string;
  answers: Array<QuizzAnswer>;
}

export interface Quizz {
  href: string;
  color: string;
  title: string;
  image: string;
  questions: Array<QuizzQuestion>;
}

export interface QuizzResponse {
  score: { title: string; value: number };
  answers: {
    title: string;
    content: Array<{ title: string; value: string; correct: boolean }>;
  };
}
